import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { removeItemRecipe } from '@/redux/utils/remove-item-recipe';
import { DeleteOrganisationQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchDeleteOrganisation: DispatchOptimisticPatchHandler<
  DeleteOrganisationQueryArg
> = (queryArg, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getOrganisations',
      undefined,
      removeItemRecipe('id', queryArg.id),
    ),
  );

  return { patch };
};
